import React, {useEffect, useState} from 'react';
import {
    CS_Recom_FormPage,
    FormPageRoot,
    Image_Recom_FormPage,
    InvalidPanel,
    Link_Recom_FormPage,
    News_Recom_FormPage,
    Pub_Recom_FormPage,
    Video_Recom_FormPage
} from "../../../index";
import {useTheme} from "../../../../common/ProjectThemeProvider";
import {checkNullJson, checkNullStr, getJsonValue, isValueBool} from "../../../../common/fusion-ui/utils/ReactUtils";
import {getAllocatedModuleName, isModuleAllocated, printError, printLog} from "../../../utils/AppUtils";
import {ModuleRouteUrls, Modules,} from "../../../config/AppConfig";
import {Select} from "../../../../common/fusion-ui";

const Res_Recom_FormPage = React.memo(() => {
    const TAG = "Res_Recom_FormPage";

    const moduleName = Modules.Resources;

    const theme = useTheme();

    const RES_OPTIONS = {
        pub: {id: Modules.Publication, text: Modules.Publication, textAlt: getAllocatedModuleName(Modules.Publication)},
        cs: {id: Modules.CaseStudy, text: Modules.CaseStudy, textAlt: getAllocatedModuleName(Modules.CaseStudy)},
        vid: {id: Modules.Videos, text: Modules.Videos, textAlt: getAllocatedModuleName(Modules.Videos)},
        img: {id: Modules.Images, text: Modules.Images, textAlt: getAllocatedModuleName(Modules.Images)},
        link: {id: Modules.UsefulLinks, text: Modules.UsefulLinks, textAlt: getAllocatedModuleName(Modules.UsefulLinks)},
        News: {id: Modules.News, text: Modules.News, textAlt: getAllocatedModuleName(Modules.News)},
    };

    const Fields = {
        isDataLoading: 'isDataLoading',
        isDataFound: 'isDataFound',
        dataLoadingMsg: 'dataLoadingMsg',

        currModuleName: 'currModuleName',
    };
    const [fieldsData, setFieldsData] = useState({});

    useEffect(() => {
        if (!checkNullStr(getField(Fields.isDataFound))) {
            updateField(Fields.isDataFound, true);
            updateField(Fields.isDataLoading, false);
            updateField(Fields.currModuleName, RES_OPTIONS.pub.id);
        }
    }, []);

    return (<>
        <FormPageRoot
            tag={TAG}
            moduleName={moduleName}
            addPageTitle={getTabTitle()}
            isDataLoading={getField(Fields.isDataLoading)}
            isDataFound={getField(Fields.isDataFound)}
            dataLoadingMsg={getField(Fields.dataLoadingMsg)}
            md={6}>
            <div>
                {/*res-select*/}
                <Select
                    id={TAG + 'res-select'}
                    wrapperClassName={`w-100`}
                    className={`w-100 rounded-3 py-2`}
                    innerWrapperClassName={'w-100'}
                    labelClassName={'w-100 text-input-label'}
                    variant={'primary'}
                    justifyAt={'start'}
                    labelColor={theme.text40}
                    label={'Select a resource'}
                    placeholder={'Select a resource'}
                    wrap={'wrap'}
                    textKey={'text'}
                    idKey={'id'}
                    required={true}
                    options={Object.values(RES_OPTIONS).filter(item => isModuleAllocated(item.text)).filter(item => checkNullJson(item) && !isValueBool(item))}
                    defOption={getField(Fields.currModuleName)}
                    onChange={(e, text, value) => {
                        log('res-select.Select.onChange::text:', text, "value:", value);
                        updateField(Fields.currModuleName, value);
                    }}
                />

                <div className={'mt-3'}>
                    {createForm()}
                </div>
            </div>
        </FormPageRoot>
    </>)

    function createForm() {
        switch (getField(Fields.currModuleName)) {
            case RES_OPTIONS.pub.id:
                return <Pub_Recom_FormPage asPanel={true} redirectUrl={ModuleRouteUrls[moduleName]}/>
            case RES_OPTIONS.cs.id:
                return <CS_Recom_FormPage asPanel={true} redirectUrl={ModuleRouteUrls[moduleName]}/>
            case RES_OPTIONS.img.id:
                return <Image_Recom_FormPage asPanel={true} redirectUrl={ModuleRouteUrls[moduleName]}/>
            case RES_OPTIONS.vid.id:
                return <Video_Recom_FormPage asPanel={true} redirectUrl={ModuleRouteUrls[moduleName]}/>
            case RES_OPTIONS.link.id:
                return <Link_Recom_FormPage asPanel={true} redirectUrl={ModuleRouteUrls[moduleName]}/>
            case RES_OPTIONS.News.id:
                return <News_Recom_FormPage asPanel={true} redirectUrl={ModuleRouteUrls[moduleName]}/>
            default :
                return <InvalidPanel
                    wrapperClassName={''}
                    labelClassName={'m-2 w-100 fs-normal'}
                    color={theme.text70}
                    success={false}
                    loading={false}
                    msg={"Unknown resource!"}
                    show404Image={true}
                />
        }
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function getTabTitle() {
        // return `Recommend a Resource`;
        return `Recommend ${getField(Fields.currModuleName)}`;
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }

    //======================Util Functions end=====================
});
export default Res_Recom_FormPage;
